import type { ComponentMeta } from "../BuilderUI.types";
import type { BlockCategoryName } from "../constants/BlockCategories";

interface AcceptsRejectsConfig {
  accepts: BlockCategoryName[];
  rejects: BlockCategoryName[];
}

export const getAcceptsRejectsConfig = (
  blockMeta: ComponentMeta,
  propName: string,
): AcceptsRejectsConfig => {
  const metaProp = blockMeta.props?.[propName];

  if (!metaProp || metaProp.prop !== "children") {
    return { accepts: [], rejects: [] };
  }

  const accepts = "accepts" in metaProp ? metaProp.accepts : [];
  const rejects = "rejects" in metaProp ? metaProp.rejects : [];

  return { accepts, rejects };
};
